<div class="data" *ngFor="let data of mapData">
    <div class="data-block">
        <p>Asset Id</p>
        <p>:</p>
        <p>{{data.objectInfoId || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Asset</p>
        <p>:</p>
        <p>{{data.name || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Name</p>
        <p>:</p>
        <p>{{data.givenName || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Group</p>
        <p>:</p>
        <p>{{data.group || '--'}}</p>
    </div>
  
    <div class="data-block">
        <p>Type</p>
        <p>:</p>
        <p>{{data.type || '--'}}</p>
    </div>
 
    <div class="data-block">
        <p>Serial Number</p>
        <p>:</p>
        <p>{{data.serialNumber || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Original Cost</p>
        <p>:</p>
        <p>{{data.originalCost || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Current Cost</p>
        <p>:</p>
        <p>{{data.currentCost || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Department</p>
        <p>:</p>
        <p>{{data.department || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Location</p>
        <p>:</p>
        <p>{{data.location || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Branch</p>
        <p>:</p>
        <p>{{data.branch || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Make</p>
        <p>:</p>
        <p>{{data.make || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Model</p>
        <p>:</p>
        <p>{{data.model || '--'}}</p>
    </div>
    <div class="data-block">
        <p>Asset Condition</p>
        <p>:</p>
        <p>{{data.objectCondition || '--'}}</p>
    </div>

</div>